import { render, staticRenderFns } from "./BookOrder.vue?vue&type=template&id=ca843786&scoped=true"
import script from "./BookOrder.vue?vue&type=script&lang=js"
export * from "./BookOrder.vue?vue&type=script&lang=js"
import style0 from "./BookOrder.vue?vue&type=style&index=0&id=ca843786&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca843786",
  null
  
)

export default component.exports